import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'inherit', // Inherit from body
  },
});

export default theme;
